import ActivateDeactivateButton from "@app/components/activate-deactivate-button.tsx";
import ActivateDeactivateIndicator from "@app/components/activate-deactivate-indicator.tsx";
import { AssignmentPhaseModel } from "@app/data/engine.ts";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (id: number) => void;
    onActivateDeactivate: (id: number, isActive: boolean) => void;
    onUpdateSortBy: (id: number, sortBy: number) => void;
    minSort: number;
    maxSort: number;
    rowCount: number;
}

const columnHelper = createColumnHelper<AssignmentPhaseModel>();
export const assignmentPhaseTableDefinition = ({
    onEdit,
    onActivateDeactivate,
    onUpdateSortBy,
    minSort,
    maxSort,
    rowCount,
}: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.assignmentPhaseId!)}>
                    <EditIcon />
                </IconButton>
                <IconButton
                    tooltip={"Move Up"}
                    onClick={() => onUpdateSortBy(item.row.original.assignmentPhaseId!, item.row.original.sortBy! - 1)}
                    disabled={item.row.original.sortBy! <= minSort}
                >
                    <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton
                    tooltip={"Move Down"}
                    onClick={() => onUpdateSortBy(item.row.original.assignmentPhaseId!, item.row.original.sortBy! + 1)}
                    disabled={item.row.original.sortBy! >= maxSort}
                >
                    <KeyboardArrowDownIcon />
                </IconButton>
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.phaseCode, { id: "phaseCode", header: "Phase Code" }),
    columnHelper.accessor((x) => x.phaseDescription, { id: "phaseDescription", header: "Phase Description" }),
    columnHelper.accessor((x) => x.sortBy, { id: "sortBy", header: "Sort By", alignment: "right" }),
    columnHelper.accessor((x) => x.active, {
        id: "active",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Active
                <ActivateDeactivateIndicator />
            </Box>
        ),
        cell: (item) => (
            <ActivateDeactivateButton
                isActive={item.getValue() ?? false}
                onClick={() => onActivateDeactivate(item.row.original.assignmentPhaseId!, !item.getValue())}
            />
        ),
    }),
];
